import PowerBIReport from './PowerBIReport';

const ClientRevenueReport = ({ reportName, clientId }: { reportName: string; clientId?: string }) => {
  if (!clientId) return null;

  return (
    <PowerBIReport
      reportName={reportName}
      filter={{ table: 'Deals Detail', column: 'clientId', value: clientId }}
      loadingText="Loading Client Analytics..."
    />
  );
};

export default ClientRevenueReport;